import _ from "lodash";

export function sortByOrder(arr: Array<Array<String>>) {
    return _.sortBy(arr, function([key,value,order]) { 
        return order;
    });
}
